module.exports = __webpack_public_path__ + "media/customizations/brookwaterlife/back-dc217af439182ca254d9e662d154f852.jpg";